<template>
    <popup :opened="dataToShow" @close="close" :min-height="'h-9/10'">
        <!-- BEGIN Content modal add hobbie -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <h3 class="mb-10">Choisir une image pour “{{hobbieToEdit.value}}“</h3>

                <div class="flex flex-col justify-center items-center">

                    <div v-if="hobbieToEdit.image && hobbieToEdit.image != ''" class="mb-8 flex flex-col items-center justify-center space-y-1 text-base">
                        <div>Image actuelle</div>
                        <img :src="hobbieToEdit.image" class="h-24 w-24 object-cover rounded-lg transform duration-300 hover:scale-200">
                        <div @click="removePic" class="text-pink-600 cursor-pointer">Supprimer l'image</div>
                    </div>

                    <div class="text-indigo-600 mb-2 text-lg flex space-x-1 items-center justify-center">
                        <p>Rechercher une image depuis la plateforme Unsplash</p>
                        <img class="object-fill h-4" src="https://cdn-icons-png.flaticon.com/512/5968/5968743.png">
                    </div>

                    <div class="mb-5 text-sm flex space-x-1 items-center justify-center">
                        <p>La recherche sera plus précise en utilisant des mots en anglais</p>
                    </div>

                    <input-text
                        placeholder="Exemple : “Musique“"
                        :value="hobbieName"
                        class="lg:w-1/2 mb-8"
                        libelle="Rechercher une image"
                        name="hobbieName"
                        @input="(newValue) => {getPhotos({search: newValue})}"
                        type="search"
                    />

                    <div v-if="listPics.length > 0 && !isLoading" class="grid grid-cols-2 md:grid-cols-5 gap-4">
                        <div 
                            v-for="(pic, i) in listPics" 
                            :key="pic.id"
                            class="col-span-1 relative" 
                            @touchstart.stop="choosePic(pic)"
                            @mouseleave="hideFiligrane();"
                            @mouseenter="showFiligrane(i);"
                        >
                            <!-- Filigrane -->
                            <transition
                                enter-active-class="ease-out duration-300"
                                enter-class="opacity-0"
                                enter-to-class="opacity-100"
                                leave-active-class="ease-in duration-200"
                                leave-class="opacity-100"
                                leave-to-class="opacity-0"
                            >
                                <div 
                                    class="top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-32 rounded-md p-6 z-20 flex justify-center items-center cursor-default" 
                                    v-if="numFiligrane === i"
                                >
                                    <!-- Filigrane contents -->
                                    <div 
                                        class="border border-pink-600 rounded-full
                                            py-1.5 px-3.5 
                                            flex justify-center  
                                            text-white text-base 
                                            w-max cursor-pointer 
                                            transition-all duration-300 hover:bg-white hover:text-indigo-600"
                                            @click.stop="choosePic(pic)"
                                    >
                                        Choisir
                                    </div>
                                    <!-- END Filigrane contents -->
                                </div>
                            </transition>
                            <!-- END Filigrane -->
                            <img 
                                :src="pic.urls.thumb" 
                                class="object-cover w-full h-32 rounded-md"
                            />
                            <div class="text-sm text-gray-600">Par <a :href="pic.links.html" class="underline" target="_blank">{{pic.user.name}}</a></div>
                        </div>
                    </div>
                    <div class="text-base" v-if="listPics.length === 0 && isLoading">
                        Recherche en cours...
                    </div>
                    <div class="text-base" v-if="listPics.length === 0 && !isLoading && hobbieName != ''">
                        Aucun résultat pour la recherche "{{hobbieName}}"
                    </div>
                </div>

            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';
import axios from 'axios';

const unsplash = axios.create({
  baseURL: 'https://api.unsplash.com',
  headers: {
    Authorization:
      'Client-ID '+process.env.MIX_UNSPLASH_ACCESS
  }
});

export default {
  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
        
    hobbieToEdit:{
      type:Object,
      required: false,
      default: null,
    },
  },

  data(){
    return {
      hobbieName: '',
      listPics:[],
      isLoading: false,
      numFiligrane: -1,
    };
  },

  methods:{
    getPhotos({search}) {
      this.isLoading = true;
      this.hobbieName = search;
      unsplash.get(`/search/photos?page=1&per_page=20&query=${search}`).then(r => {
        this.listPics = r.data.results;
        this.isLoading = false;
      }).catch(err => {
        console.log(err.response.data);
        this.isLoading = false;
      });
    },

    close(){
      this.$emit('close');
      this.hobbieName = '';
      this.listPics = [];
    },

    showFiligrane(num){
      this.numFiligrane = num;
    },

    hideFiligrane(){
      this.numFiligrane = -1;
    },

    choosePic(pic){
      this.$emit('changePic', pic.urls.thumb);
      this.close();
    },

    removePic(){
      this.$emit('removePic');
      this.close();
    }
  },
  watch:{
    //
  }
};
</script>
